import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

require('@/assets/scss/modal.scss');

createApp(App)
  .use(router)
  .mount('#app');
